if (!customElements.get('ax-text-photo-slider')) {
  customElements.define('ax-text-photo-slider', class AxTextPhotoSlider extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    init() {
      const slider = this.querySelector('.swiper');
      if (!slider) return;

      const initSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }

        this.swiper = new Swiper(slider, {
          slidesPerView: 1.2,
          spaceBetween: 12,
          loop: false,
          freeMode: {
            enabled: true,
            momentumBounce: false,
          },
          mousewheel: {
            forceToAxis: true,
          },
          scrollbar: {
            el: this.querySelector('.ax-text-photo-slider__scrollbar'),
            draggable: true,
            snapOnRelease: false,
          },
          breakpoints: {
            750: {
              slidesPerView: 2.5,
              spaceBetween: 16,
            },
          },
        });
      };

      initSwiper();
    }
  });
}
